import {
  Box,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import React from "react";
import MenuIcon from "@mui/icons-material/Menu";
import { useClasses } from "./AppDrawer.styles";

type Props = {
  open?: boolean;
  handleDrawerToggle: () => void;
};

export function AppDrawerIcon(props: Readonly<Props>) {
  const classes = useClasses();
  return (
    <IconButton
      color="inherit"
      aria-label="open drawer"
      edge="start"
      onClick={props.handleDrawerToggle}
      sx={classes.appDrawerIcon}
    >
      <MenuIcon />
    </IconButton>
  );
}

export function AppDrawer(props: Readonly<Props>) {
  const drawerWidth = 240;
  const navItems = ["Home", "About", "Contact"];

  const drawer = (
    <Box onClick={props.handleDrawerToggle} sx={{ textAlign: "center" }}>
      <Typography variant="h6" sx={{ my: 2 }}>
        MUI
      </Typography>
      <Divider />
      <List>
        {navItems.map((item) => (
          <ListItem key={item} disablePadding>
            <ListItemButton sx={{ textAlign: "center" }}>
              <ListItemText primary={item} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
  const container =
    window !== undefined ? () => window.document.body : undefined;
  return (
    <Drawer
      container={container}
      variant="temporary"
      open={props.open}
      onClose={props.handleDrawerToggle}
      ModalProps={{
        keepMounted: true, // Better open performance on mobile.
      }}
      sx={{
        display: { sm: "block", md: "none" },
        "& .MuiDrawer-paper": {
          boxSizing: "border-box",
          width: drawerWidth,
        },
      }}
    >
      {drawer}
    </Drawer>
  );
}
